import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { AlertProvider, useAlert } from './contexts/AlertContext'
import LoginPage from './pages/Login'
import SuperAdminPage from './pages/SuperAdmin'
import AdminPage from './pages/Admin'
import ViewerPage from './pages/Viewer'

const AuthCallback = () => {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code') || ''
  const inputRef = React.useRef(null)
  const { alert } = useAlert()

  React.useEffect(() => {
    if (!code) return
    // Log to console so it's always retrievable
    try { /* console.log('Zoho Authorization Code:', code) */ } catch (_) {}
    // Attempt auto-copy for convenience
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(code).catch(() => {})
    }
  }, [code])

  const handleCopy = () => {
    if (!code) return
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(code).catch(() => {})
    }
    if (inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
    alert.success('Authorization code copied to clipboard.')
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999, // ensure above any overlay
        background: 'rgba(0,0,0,0.85)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24
      }}
    >
      <div style={{ maxWidth: 800, width: '100%', textAlign: 'center' }}>
        <h2 style={{ marginBottom: 12 }}>Zoho CRM Authorization</h2>
        {code ? (
          <>
            <p style={{ marginBottom: 16 }}>Authorization successful! Copy the code below and use it in the next step.</p>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
              <input
                ref={inputRef}
                value={code}
                readOnly
                onFocus={(e) => e.target.select()}
                style={{
                  width: '100%',
                  maxWidth: 700,
                  padding: '10px 12px',
                  borderRadius: 6,
                  border: '1px solid #9ca3af',
                  background: '#111827',
                  color: '#e5e7eb'
                }}
              />
              <button onClick={handleCopy} style={{ padding: '10px 14px', borderRadius: 6, background: '#2563eb', color: '#fff', border: 'none', cursor: 'pointer' }}>
                Copy
              </button>
            </div>
            <p style={{ marginTop: 12, fontSize: 12, color: '#9ca3af' }}>The code is also printed in the browser console.</p>
          </>
        ) : (
          <p>No authorization code found.</p>
        )}
      </div>
    </div>
  )
}

const RouteGuard = ({ children, allow }) => {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (allow && !allow.includes(user.role)) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <AlertProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/super-admin"
              element={
                <RouteGuard allow={["SUPER_ADMIN"]}>
                  <SuperAdminPage />
                </RouteGuard>
              }
            />
            <Route
              path="/admin"
              element={
                <RouteGuard allow={["ADMIN", "SUPER_ADMIN"]}>
                  <AdminPage />
                </RouteGuard>
              }
            />
            <Route path="/viewer" element={<ViewerPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AlertProvider>
    </AuthProvider>
  )
}


